module.exports = __webpack_public_path__ + "img/bg-2.92e9ab5.png";